export class Suggestion {
  constructor(
    public id: number,
    public text: string,
    public textWithHighlight: string,
    public type: string,
    public isSubType?: boolean
  ) {}
}
